module.exports = __webpack_public_path__ + "img/6.73ff5116.png";